'use strict';

angular.module('app.newMentions', [])
    .controller('newMentionsCtrl', ['$scope', '$rootScope', '$modal', 'newMentionsService', '$http', 'mentionManagementService',
        function ($scope, $rootScope, $modal, newMentionsService, $http, mentionManagementService) {
            $scope.selectedMentionRow = null;
            $scope.checkedMentionRow = null;
            $scope.selectedTopicRow = -1;
            $scope.checkedTopicRow = null;
            $scope.selectedVerticalRow = -1;
            $scope.checkedVerticalRow = null;
            $scope.flag = false;
            $scope.firstLoad = true; // Parameter indicate the new mentions page is first load or not
            $scope.mentions = [];

            function clearSelections() {
                $scope.selectedMentionRow = null;
                $scope.selectedTopicRow = null;
                $scope.selectedVerticalRow = null;

                angular.forEach($scope.languages, function (item) {
                    item.ticked = false;
                })
            }

            $scope.loadData = function () {
                newMentionsService.getNewMentions(true)
                    .then(function (response) {
                        $scope.mentions = response.data;
                        angular.forEach(response.data, function (data) {
                            if (data.keywordType.name == "Url") {
                                data.keywordType.name = "URL";
                            }
                            if (data.keywordType.name == "Hash") {
                                data.keywordType.name = "Hashtag";
                            }
                        })
                        $scope.number = response.data.length;
                        $scope.flag = true;
                        if ($scope.firstLoad == true) {
                            //If the new mentions page is first load, everthing is original
                            $scope.firstLoad = false;
                            clearSelections();
                        } else {
                            // If the new mentions page is not first load, select the first mention in mention list
                            // i.e the system will select the first mention after set approve or not approve in this page
                            // After add new mention action, everthing will be set to original. Row 495 mentions that
                            if ($scope.mentions.length > 0) {
                                $scope.setClickedMentionRow($scope.mentions[0]);
                            } else {
                                clearSelections();
                            }
                        }
                    }, function (response) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = response.message;
                    })
            }

            mentionManagementService.getLanguagesOfInterestingCountries(false)
                .then(function (response) {
                    $scope.languages = response.data;
                }, function (errResponse) {
                    var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = errResponse.message;
                })

            $scope.topics = [];
            var topicObject = {
                id: 1,
                name: "No Topic"
            }
            $scope.topics.push(topicObject);

            $scope.verticals = [];
            var VerticalObject = {
                id: 1,
                name: "No Industry"
            }
            $scope.verticals.push(VerticalObject);

            var url_getTopics = $rootScope.apiUrl + 'mention/getAllTopic';
            $http.get(url_getTopics, {
                loader: false
            })
                .success(function (responseGetAllTopic) {
                    angular.forEach(responseGetAllTopic.data, function (item) {
                        $scope.topics.push(item);
                    })
                })
            var url_getVertical = $rootScope.apiUrl + 'mention/getAllVertical';
            $http.get(url_getVertical, {
                loader: false
            })
                .success(function (responseGetAllVertical) {
                    angular.forEach(responseGetAllVertical.data, function (item) {
                        $scope.verticals.push(item);
                    })
                    if ($scope.flag == false) {
                        $scope.loadData();
                    }
                })

            $scope.newMentionHandler = function () {
                var modalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/admin/mention/newMentions/addNewMention/addNewMention.html?app_v=deployDate',
                    controller: 'addNewMentionCtrl'
                });
            }

            $scope.setClickedMentionRow = function (mention) {
                $scope.checkedMentionRow = mention.id;
                $scope.selectedKeyword = mention.keyword;
                if ($scope.selectedMentionRow == $scope.checkedMentionRow) {
                    $scope.selectedMentionRow = null;
                    $scope.selectedTopicRow = null;
                    $scope.selectedVerticalRow = null;
                    angular.forEach($scope.languages, function (item) {
                        item.ticked = false;
                    })
                    return;
                }
                $scope.selectedMentionRow = $scope.checkedMentionRow;
                $scope.selectedTopicRow = mention.topic[0] != null ? mention.topic[0].id : null;
                $scope.selectedVerticalRow = mention.vertical[0] != null ? mention.vertical[0].id : null;
                angular.forEach($scope.languages, function (item) {
                    item.ticked = false;
                })

                $scope.disableLanguages = false;
                if (mention.keywordType.id == 1) {
                    $scope.disableLanguages = false;
                } else {
                    $scope.disableLanguages = true;
                }

                if (mention.is_global == 1) {
                    angular.forEach($scope.languages, function (item) {
                        if (item.name == "Global") {
                            item.ticked = true;
                            $scope.oldSelectedLanguage = item;
                        }
                    })
                } else {
                    angular.forEach(mention.languages, function (result) {
                        angular.forEach($scope.languages, function (item) {
                            if (item.name == result.name) {
                                item.ticked = true;
                                $scope.oldSelectedLanguage = item;
                            }
                        })
                    })
                }

                $scope.duplicatedMentions = [];

                newMentionsService.getDuplicatedMentions(encodeURIComponent(mention.keyword), mention.keywordType.id, true)
                    .then(function (duplicatesMention) {
                        if (duplicatesMention.data && duplicatesMention.data.length > 0) {
                            duplicatesMention.data.forEach(function (mention) {
                                if (mention.id !== $scope.selectedMentionRow && mention.languages) {
                                    if (mention.is_global === 1) {
                                        $scope.duplicatedMentions.push({
                                            id: mention.id,
                                            keyword: mention.keyword,
                                            language: 'Global'
                                        });
                                    } else {
                                        mention.languages.forEach(function (language) {
                                            $scope.duplicatedMentions.push({
                                                id: mention.id,
                                                keyword: mention.keyword,
                                                language: language.name
                                            })
                                        });
                                    }
                                }
                            });
                        }
                    }).catch(function (errResponse) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = errResponse.message;
                    });
            }

            $scope.setClickedTopicRow = function (id) {
                $scope.checkedTopicRow = id;
                if ($scope.selectedTopicRow == $scope.checkedTopicRow) {
                    $("[name='topic']").removeClass('selected');
                    $scope.checkedTopicRow = null;
                }
                $scope.selectedTopicRow = $scope.checkedTopicRow;
            }

            $scope.setClickedVerticalRow = function (id) {
                $scope.checkedVerticalRow = id;
                if ($scope.selectedVerticalRow == $scope.checkedVerticalRow) {
                    $("[name='vertical']").removeClass('selected');
                    $scope.checkedVerticalRow = null;
                }
                $scope.selectedVerticalRow = $scope.checkedVerticalRow;
            }

            $scope.setApprovedMention = function (id) {
                if ($scope.checkedMentionRow == null) {
                    var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = "Please choose mention for this action";
                } else {
                    var selectedlanguages = [];
                    angular.forEach($scope.languages, function (item) {
                        if (item.ticked) {
                            selectedlanguages.push(item.id);
                        }
                    })

                    var data = {
                        topic_id: $scope.selectedTopicRow,
                        vertical_id: $scope.selectedVerticalRow,
                        languages: selectedlanguages
                    }

                    if ($scope.oldSelectedLanguage.id != selectedlanguages[0]) {
                        $scope.checkKeyword = encodeURIComponent($scope.selectedKeyword);
                        newMentionsService.checkNewMention($scope.checkKeyword, selectedlanguages[0], "update", true)
                            .then(function (responseCheckNewMention) {
                                newMentionsService.setApprovedMention(id, data, true)
                                    .then(function (responseSetApprovedMention) {
                                        $scope.loadData();
                                    }, function (responseSetApprovedMention) {
                                        var errorModalInstance = $modal.open({
                                            scope: $scope,
                                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                            windowClass: 'modal-dialog-mention-error'
                                        });
                                        $scope.errorModalInstance = errorModalInstance;
                                        $scope.errorMessage = responseSetApprovedMention.message;
                                    })
                            }, function (responseCheckNewMention) {
                                var errorModalInstance = $modal.open({
                                    scope: $scope,
                                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                    windowClass: 'modal-dialog-mention-error'
                                });
                                $scope.errorModalInstance = errorModalInstance;
                                $scope.errorMessage = responseCheckNewMention.message;
                            })
                    } else {
                        newMentionsService.setApprovedMention(id, data, true)
                            .then(function (responseSetApprovedMention) {
                                $scope.loadData();
                            }, function (responseSetApprovedMention) {
                                var errorModalInstance = $modal.open({
                                    scope: $scope,
                                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                    windowClass: 'modal-dialog-mention-error'
                                });
                                $scope.errorModalInstance = errorModalInstance;
                                $scope.errorMessage = responseSetApprovedMention.message;
                            })
                    }
                }
            }

            $scope.setNotApprovedMention = function (id) {
                if ($scope.checkedMentionRow == null) {
                    var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = "Please choose mention for this action";
                } else {
                    var selectedlanguages = [];

                    angular.forEach($scope.languages, function (item) {
                        if (item.ticked) {
                            selectedlanguages.push(item.id);
                        }
                    })

                    var data = {
                        topic_id: $scope.selectedTopicRow,
                        vertical_id: $scope.selectedVerticalRow,
                        languages: selectedlanguages
                    }

                    if ($scope.oldSelectedLanguage.id != selectedlanguages[0]) {
                        $scope.checkKeyword = encodeURIComponent($scope.selectedKeyword);
                        newMentionsService.checkNewMention($scope.checkKeyword, selectedlanguages[0], "update", true)
                            .then(function (responseCheckNewMention) {
                                newMentionsService.setNotApprovedMention(id, data, true)
                                    .then(function (responseSetNotApprovedMention) {
                                        $scope.loadData();
                                    }, function (responseSetNotApprovedMention) {
                                        var errorModalInstance = $modal.open({
                                            scope: $scope,
                                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                            windowClass: 'modal-dialog-mention-error'
                                        });
                                        $scope.errorModalInstance = errorModalInstance;
                                        $scope.errorMessage = responseSetNotApprovedMention.message;
                                    })
                            }, function (responseCheckNewMention) {
                                var errorModalInstance = $modal.open({
                                    scope: $scope,
                                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                    windowClass: 'modal-dialog-mention-error'
                                });
                                $scope.errorModalInstance = errorModalInstance;
                                $scope.errorMessage = responseCheckNewMention.message;
                            })
                    } else {
                        newMentionsService.setNotApprovedMention(id, data, true)
                            .then(function (responseSetNotApprovedMention) {
                                $scope.loadData();
                            }, function (responseSetNotApprovedMention) {
                                var errorModalInstance = $modal.open({
                                    scope: $scope,
                                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                    windowClass: 'modal-dialog-mention-error'
                                });
                                $scope.errorModalInstance = errorModalInstance;
                                $scope.errorMessage = responseSetNotApprovedMention.message;
                            })
                    }
                }
            }

            $scope.mentionDetails = function (id) {
                var mentionDetailsModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/admin/mention/mentions/mentionDetail/mentionDetail.html?app_v=deployDate',
                    controller: 'mentionDetailCtrl',
                });
                $scope.id = id;
                $scope.mentionDetailsModalInstance = mentionDetailsModalInstance;
            }
        }
    ])